export class AccountMetaKeys {
    public static readonly SALESMAN = "salesman";

    /**
     * Added by the authorization service when a user deletes their own account.
     * The value is the deletion time as epoch milliseconds.
     */
    public static readonly DELETED_ON = "deleted_on";
}
